<template>
  <div>
    <a v-if="canCreate(permissionKey)" href="#/campaigns/new" :disabled="!isActive" class="button is-success">
      <span class="icon">
        <i class="fa fa-plus-circle"></i>
      </span>
      <span>Создать рассылку</span>
    </a>
    <div class="control is-grouped">
      <button class="button is-info is-outlined" :disabled="true">
        <span class="icon">
          <i class="fa fa-search"></i>
        </span>
        <span>Поиск</span>
      </button>
      <input v-model="searchName" class="input" type="text" placeholder="Введите название рассылки" v-on:change="searchByName">
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
                <tr>
                  <th @click="sort('name')">Название{{sortIcon('name')}}</th>
                  <th @click="sort('client')">Клиент{{sortIcon('client')}}</th>
                  <th @click="sort('scenario')">Сценарий{{sortIcon('scenario')}}</th>
                  <th @click="sort('sortingDate')">Прозвон{{sortIcon('sortingDate')}}</th>
                  <th @click="sort('state')">Статус{{sortIcon('state')}}</th>
                  <th @click="sort('dateCreated')">Дата создания{{sortIcon('dateCreated')}}</th>
                  <th @click="sort('sumConsume')">Сумма{{sortIcon('sumConsume')}}</th>
                  <th>Отчет</th>
                  <th>Действие</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(campaign, index) in sortedCampaigns">
                  <td>
                    <a :href="'#/campaigns/'+campaign.id">{{campaign.name}}</a>
                  </td>
                  <td>
                    {{campaign.client}}
                  </td>
                  <td>
                    <a :href="'#/scenarios/0/'+campaign.scenario">{{campaign.scenarioName}}</a>
                  </td>
                  <td>
                    {{getDate(campaign.sortingDate)}} {{campaign.timeStart}}-{{campaign.timeEnd}} {{campaign.zoneOffset}} UTC
                  </td>
                  <td>
                    <button class="button is-info is-outlined" :disabled="true" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-info"></i>
                      </span>
                      <span>{{campaign.state}}</span>
                    </button>
                    <tooltip label="Если в завершенной рассылке остались необработанные номера, укажите новые дату и время рассылки и подтвердите ее готовность для запуска" placement="top" type="warning">
                    <button v-if="canContinue(campaign)" class="button is-warning" v-on:click="getReadyCallTasksCSV(campaign)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-info"></i>
                      </span>
                      <span>Необработанные</span>
                    </button>
                    </tooltip>
                    <tooltip label="Подтвердите готовность рассылки и она запустится в указанные дату и время" placement="top" type="info">
                    <button v-if="canSetReadyStatus(campaign)" :disabled="!isActive" class="button is-info" v-on:click="openModal(campaign, 'readyStatus')" v-bind:disabled="appconfig.disableCampaignSetReadyState"  style="width:100%">
                      <span class="icon">
                        <i class="fa fa-check-circle"></i>
                      </span>
                      <span>Запустить</span>
                    </button>
                    </tooltip>
                  </td>
                  <td>
                    {{getDate(campaign.dateCreated)}}
                  </td>
                  <td>
                    {{campaign.sumConsume}}
                  </td>
                  <td>
                    <!--<a v-if="campaign.state=='Завершена'" href="#">Отчет</a>-->
                    <button class="button is-info" v-on:click="viewMonitor(campaign)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-tv"></i>
                      </span>
                      <span>Мониторинг</span>
                    </button>
                    <div class="control">
                      <button v-if="campaign.state=='Завершена'" class="button is-info" v-on:click="getReportCSV(campaign)" style="width:100%">
                        <span class="icon">
                          <i class="fa fa-download"></i>
                        </span>
                        <span>Отчет в CSV</span>
                      </button>
                      <!--<button v-if="campaign.state=='Завершена' && !campaign.reportCreated" class="button is-info" v-on:click="prepareReport(campaign)">
                      <span class="icon">
                        <i class="fa fa-calculator"></i>
                      </span>
                        <span>Подготовить отчет</span>
                      </button>-->
                    <button v-if="campaign.state=='Завершена'" :disabled="!isActive" class="button is-info" v-on:click="getSumConsume(campaign)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-calculator"></i>
                      </span>
                      <span>Стоимость</span>
                    </button>
                    </div>
                  </td>
                  <td>
                    <a v-if="canCreate(permissionKey)" :href="'#/campaigns/copy/'+campaign.id"  :disabled="!isActive" class="button is-success"  style="width:100%">
                      <span class="icon">
                        <i class="fa fa-copy"></i>
                      </span>
                      <span>Копировать</span>
                    </a>
                    <button v-if="!canDeleteState(campaign) && canDelete(permissionKey)" :disabled="!isActive" class="button is-light" v-on:click="openModal(campaign, 'archive')" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-archive"></i>
                      </span>
                      <span>В архив</span>
                    </button>
                    <button v-if="canDeleteState(campaign) && canDelete(permissionKey)" :disabled="!isActive" class="button is-light" v-on:click="openModal(campaign, 'delete')" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                      <span>Удалить</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div id="page-navigation">
            <ul class="pagination">
              <li class="pagination-item">
                <button
                  type="button"
                  @click="onClickFirstPage"
                  :disabled="isInFirstPage"
                  aria-label="Go to first page"
                >
                  Первая
                </button>
              </li>
              <li class="pagination-item">
                <button
                  type="button"
                  @click="onClickPreviousPage"
                  :disabled="isInFirstPage"
                  aria-label="Go to previous page"
                >
                  Предыдущая
                </button>
              </li>
              <li v-for="page in pages" class="pagination-item">
                <button
                  type="button"
                  @click="onClickPage(page.name)"
                  :disabled="page.isDisabled"
                  :class="{ activepage: isPageActive(page.name) }"
                  :aria-label="`Go to page number ${page.name}`"
                >
                  {{ page.name }}
                </button>
              </li>
              <li class="pagination-item">
                <button
                  type="button"
                  @click="onClickNextPage"
                  :disabled="isInLastPage"
                  aria-label="Go to next page"
                >
                  Следующая
                </button>
              </li>
              <li class="pagination-item">
                <button
                  type="button"
                  @click="onClickLastPage"
                  :disabled="isInLastPage"
                  aria-label="Go to last page"
                >
                  Последняя
                </button>
              </li>
            </ul>
          </div>
        </article>
        <modal :visible="showModal" :title=title :confirmation=confirmation :clipboard=false @confirm="confirmAction" @close="closeModal"></modal>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'vue-bulma-chartjs'
import Modal from './Modal'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Notification from 'vue-bulma-notification'
import Message from 'vue-bulma-message'
import Tooltip from 'vue-bulma-tooltip'
import CheckToken from '../authentication/CheckToken'
import CheckPermission from '../authentication/CheckPermission'

Vue.mixin(CheckToken)
Vue.mixin(CheckPermission)

const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}

const MessageComponent = Vue.extend(Message)
const openMessage = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 10000,
  container: '.messages'
}) => {
  return new MessageComponent({
    el: document.createElement('div'),
    propsData
  })
}


const CAMPAIGN_API = '/api/campaigns'
const REPORTS_API = '/calls'
const CALLTASKS_API = '/outgoing-cpg'
const APPCONFIG_API = '/api/appConfig'
const PROFILES_API = '/api/profiles'

export default {
  components: {
    Chart,
    Modal,
    Message,
    Notification,
    Tooltip
  },

  data () {
    return {
      campaigns: [],
      sortedCampaigns: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'dateCreated',
      currentSortDir: 'desc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      searchName: '',
      campaignToDelete: null,
      campaignToArchive: null,
      campaignToReady: null,
      showModal: null,
      title: '',
      confirmation: true,
      appconfig: {},
      isActive: false,
      permissionKey: 'campaign'
    }
  },

  created: function () {
    this.checkToken()
    this.loadState()
    this.loadAppConfig()
    this.loadData()
  },

  computed: {
    ...mapGetters([
      'loggedId',
      'clientId',
      'authenticationToken'
    ]),
    totalPages() {
      return Math.max(Math.ceil(this.campaigns.length / this.perPage), 1)
    },
    startPage() {
      if (this.currentPage === 1) {
        return 1
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1)
      }

      return this.currentPage - 1
    },
    endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages)
    },
    pages() {
      const range = []
      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        })
      }
      return range
    },
    isInFirstPage() {
      return this.currentPage === 1
    },
    isInLastPage() {
      return this.currentPage === this.totalPages
    }
  },

  methods: {
    prepareSecurityHeader() {
      console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`
      }
    },
    loadData () {
      this.$http.get(CAMPAIGN_API, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.campaigns = response.data
          this.sortedCampaigns = this.sortedCamp()
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки списка рассылок. ')
        })
    },
    loadState () {
      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        this.isActive = response.data
        if (!this.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          })
        }
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ')
      })
    },
    loadAppConfig () {
      this.$http.get(APPCONFIG_API + '/' + this.clientId, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.appconfig = response.data
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ')
        })
    },
    sortedCamp() {
      return this.campaigns
        .filter(this.filterByName)
        .sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      }).filter((row, index) => {
        let start = (this.currentPage - 1) * this.perPage
        let end = this.currentPage * this.perPage
        if (index >= start && index < end) return true
      })
    },
    sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
      this.sortedCampaigns = this.sortedCamp()
    },
    filterByName : function(campaign) {
      if (this.searchName.length === 0) {
        return true
      }
      return (campaign.name.toLowerCase().indexOf(this.searchName.toLowerCase()) > -1)
    },
    searchByName() {
      this.sortedCampaigns = this.sortedCamp()
    },
    sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon
        } else {
          return this.descIcon
        }
      } else {
        return ''
      }
    },
    closeModal () {
      this.campaignToDelete = null
      this.campaignToArchive = null
      this.campaignToReady = null
      this.showModal = false
    },
    openModal (campaign, type) {
      if (type == 'archive') {
        this.campaignToArchive = campaign
        this.campaignToDelete = null
        this.campaignToReady = null
        this.title = 'Перенести рассылку в архив?'
        this.confirmation = true
      }
      if (type == 'delete') {
        this.campaignToDelete = campaign
        this.campaignToArchive = null
        this.campaignToReady = null
        this.title = 'Удалить рассылку?'
        this.confirmation = true
      }
      if (type == 'readyStatus') {
        this.campaignToDelete = null
        this.campaignToArchive = null
        this.campaignToReady = campaign
        this.title = 'Подтверждаете готовность рассылки?'
        this.confirmation = true
      }
      this.showModal = true
    },
    confirmAction () {
      if (this.campaignToDelete) {
        this.removeCampaign()
        this.campaignToDelete = null
      }
      if (this.campaignToArchive) {
        this.addToArchive()
        this.campaignToArchive = null
      }
      if (this.campaignToReady) {
        this.setReadyStatus()
        this.campaignToReady = null
      }
      this.closeModal()
    },
    addToArchive () {
      this.campaignToArchive.archiveStatus = true
      this.$http.put(CAMPAIGN_API, this.campaignToArchive, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('info', 'Рассылка помещена в архив.')
          this.campaigns = this.loadData()
//          this.$router.push('/archive/')
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка переноса в архив. ')
        })
    },
    removeCampaign () {
      this.$http.delete(`${CAMPAIGN_API}/${this.campaignToDelete.id}`, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('info', 'Рассылка удалена.')
          this.campaigns = this.loadData()
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка удаления рассылки. ')
        })
    },
    copyCampaign(campaign) {
     // <a href="#/campaigns/new" :disabled="!isActive" class="button is-success">
      this.$router.push('/copy/' + campaign.id)
      // <a :href="'#/campaigns/'+campaign.id">{{campaign.name}}</a>
    },
    isRemove (index) {
      // return (this.isDependentCallTask(index) || this.isReadyCallTask(index))
      // return this.isDependentCallTask(index)
      return !this.campaigns[index].hasPerformedTasks
    },
    isDependentCallTask (index) {
      return this.campaigns[index].phones === 0
    },
    isReadyCallTask (index) {
      this.$http.get(`${CALLTASKS_API}/${this.campaigns[index].id}`, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          const readyArray = this.handleReadyState(response.data)
          return readyArray.length > 0
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleReadyState (callTaskList) {
      return callTaskList.filter(function (callTask) {
        return callTask.state === 'READY'
      })
    },
    canDeleteState(campaign) {
      return (campaign.state === 'Подготовлена' || campaign.state === 'В разработке') && !campaign.hasPerformedTasks
    },
    setReadyStatus () {
      this.campaignToReady.state = 'Подготовлена'
      this.$http.put(CAMPAIGN_API, this.campaignToReady, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('info', 'Рассылка готова к запуску.')
          this.campaigns = this.loadData()
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка запуска рассылки. ')
        })
    },
    canSetReadyStatus(campaign) {
      let result = ((campaign.state == 'В разработке' || this.canContinue(campaign)) &&
        this.canModerate(this.permissionKey) && campaign.client != null &&
        campaign.date != null && campaign.scenario != null && campaign.zoneOffset != null &&
        campaign.timeStart != null && campaign.timeEnd &&
        ((campaign.postponingIntervalMin == 0 && campaign.postponingAttempts == 0) ||
          (campaign.postponingIntervalMin != 0 && campaign.postponingAttempts != 0))) ||
        this.appconfig.campaignSetReadyButtonVisibleForAll
      return result
    },
    canContinue(campaign) {
      return campaign.state == 'Завершена' && campaign.hasReadyTasks
    },
    prepareReport (campaign) {
      this.$http.get('/report/prepareReportByCampaignId?campaignId=' + campaign.id)
        .then((response) => {
          this.openNotificationWithType('info', 'Отчет подготовлен')
          this.campaigns = this.loadData()
        })
        .catch((error) => {
          this.openNotificationWithType('warning', 'Отчет формируется. Пожалуйста, загрузите его чуть позже.' +
            ' Необходимо будет обновить эту страницу, нажав Ctrl+F5')
          console.log(error)
        })
    },
    viewMonitor (campaign) {
      this.$router.push('/monitoring/' + campaign.id)
    },
    getReportCSV (campaign) {
      // this.$http.get('/report/reportByCampaignId.csv?campaignId=' + campaign.id)
      this.$http.get(`${REPORTS_API}/id/${campaign.id}/win/csv?audioPath=${campaign.recordHost + '/' + campaign.clientId + '/' + campaign.id}`, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          var s = response.headers['content-disposition']
          var res = s.split('filename="').pop()
          res = res.split('"')[0]
          let blob = new Blob([response.data], { type: 'text/csv' })
          var a = window.document.createElement('a')
          a.href = window.URL.createObjectURL(blob)
          // a.download = 'ReportByCampaign_' + campaign.name + '.csv'
          a.download = res
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
        .catch((error) => {
          this.openNotificationWithType('danger', 'Ошибка загрузки отчета')
          console.log(error)
        })
    },
    getReadyCallTasksCSV (campaign) {
      this.$http.get(CALLTASKS_API + '/readyCallTasksByCampaignId.csv?campaignId=' + campaign.id)
        .then((response) => {
          let blob = new Blob([response.data], { type: 'text/csv' })
          var a = window.document.createElement('a')
          a.href = window.URL.createObjectURL(blob)
          a.download = 'readyCallTasksByCampaign_' + campaign.name + '.csv'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
        .catch((error) => {
          this.openNotificationWithType('danger', 'Ошибка загрузки отчета')
          console.log(error)
        })
    },
    getSumConsume (campaign) {
      console.log(campaign.id)
      this.$http.get(CAMPAIGN_API + '/sumConsume/' + campaign.id, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('info', 'Сумма расчитана.')
          this.campaigns = this.loadData()
//          this.$router.push('/archive/')
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка рассчета суммы. ')
        })
    },
    getDate(date) {
      var d = new Date(Number(date))
      var day = d.getUTCDate()
      var month = d.getUTCMonth() + 1
      var year = d.getUTCFullYear()
      if (day < 10) day = '0' + day
      if (month < 10) month = '0' + month
      return day + '.' + month + '.' + year
    },
    onClickFirstPage() {
      this.onPageChange(1)
    },
    onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1)
    },
    onClickPage(page) {
      this.onPageChange(page)
    },
    onClickNextPage() {
      this.onPageChange(this.currentPage + 1)
    },
    onClickLastPage() {
      this.onPageChange(this.totalPages)
    },
    isPageActive(page) {
      return this.currentPage === page
    },
    onPageChange(page) {
      this.currentPage = page
      this.sortedCampaigns = this.sortedCamp()
    },
    toggleDropdown (event) {
      event.currentTarget.classList.toggle('is-active')
    },
    openNotificationWithType (type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      })
    }
  }
}
</script>

<style lang="scss">
.table-responsive {
  display: block;
  width: 100%;
  min-height: .01%;
  overflow-x: auto;
}
.button {
  margin: 0 0 8px 0;
}

#page-navigation {
  display: flex;
}
.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}

.activepage {
  background-color: #4AAE9B;
  color: #ffffff;
}

.tooltip {
  display: inherit;
}

.table > thead > tr > th {
  text-align: center;
}

.dropdown {
  &__header {
    position: relative;
    i.fa {
      position: absolute;
      right: 10px;
      top: 35%;
      transform: translateY(-50%);
      transition: opacity .3s;
      color: white;
      &.fa-angle-up {
        opacity: 0;
      }
    }
    &.is-active {
      i.fa {
        &.fa-angle-up {
          opacity: 1;
        }
        &.fa-angle-down {
          opacity: 0;
        }
      }
      + .dropdown__content {
        height: auto;
        opacity: 1;
        visibility: visible;
      }
    }
  }
  &__content {
    height: 0;
    opacity: 0;
    overflow: hidden;
    transition: opacity .3s;
    visibility: hidden;
  }
}

</style>



// WEBPACK FOOTER //
// Campaigns.vue?70256a7c